<template>
  <v-speed-dial v-model="isFilterOpen" direction="bottom" transition="slide-y-transition">
    <template v-slot:activator>
      <v-btn ripple flat small class="dial-align pa-0 ma-0" style="height: auto;">
        <span class="caption">{{ selectedFilter.name }}</span>
        <v-icon size="16px" class="rotate-arrow-transition" :class="{ 'rotate-arrow': isFilterOpen }">$vuetify.icons.arrowDown</v-icon>
      </v-btn>
    </template>
    <v-btn v-for="(filter, index) of filters" :key="index"
           outline round
           class="body-2 pa-0 ma-0 filter"
           :class="filter.name === selectedFilter.name ? 'filter-active' : 'filter-inactive'"
           :color="filter.name === selectedFilter.name ? '#ec2f54' : '#707070'"
           style="height: auto; margin-top: 6px !important; background-color: white !important;"
           @click="selectedFilter = filter">
      {{ filter.name }}
    </v-btn>
  </v-speed-dial>
</template>

<script>
  export default {
    name: 'sortButton',
    props: [ 'initFilter' ],
    data () {
      return {
        isFilterOpen: false,
        selectedFilter: this.initFilter,
        filters: [
          { name: '최신순' },
          { name: '인기순' },
        ],
      };
    },
    watch: {
      selectedFilter (filter) {
        this.$emit('update:initFilter', filter);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .caption {
    color: map_get($colors, brownish-grey);
  }

  /deep/.filter {
    min-width: 0;
    font-weight: 400;
    .v-btn__content {
      flex: 0 0 0;
      margin: 0;
    }
    &-active {
      padding: 5px 30px !important;
    }
    &-inactive {
      padding: 5px 16px !important;
    }
  }

  .rotate-arrow {
    transform: rotate(180deg);
    &-transition {
      transition: all .3s ease !important;
    }
  }

  /deep/.dial-align {
    min-width: 0;
    .v-btn__content {
      justify-content: flex-end;
      align-items: flex-end;
    }
  }

  /deep/ .v-speed-dial__list {
    z-index: 1;
    align-items: flex-end;
  }

</style>
